import api from './api';
import type { LoginResponse, User, ImpersonateResponse } from '../types';

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  async me(): Promise<User> {
    const response = await api.get('/auth/me');
    return response.data.user;
  },

  async refresh(refreshToken: string): Promise<{ accessToken: string }> {
    const response = await api.post('/auth/refresh', { refreshToken });
    return response.data;
  },

  logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('adminToken');
    localStorage.removeItem('impersonatedBy');
  },

  async impersonate(userId: string): Promise<ImpersonateResponse> {
    const response = await api.post('/auth/impersonate', { userId });
    return response.data;
  },

  // Password reset methods
  async forgotPassword(email: string): Promise<{ message: string }> {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  async verifyResetCode(email: string, code: string): Promise<{ message: string }> {
    const response = await api.post('/auth/verify-reset-code', { email, code });
    return response.data;
  },

  async resetPassword(email: string, code: string, newPassword: string): Promise<{ message: string }> {
    const response = await api.post('/auth/reset-password', { email, code, newPassword });
    return response.data;
  },
};
